import EducationActions from './actions'

const initialState = {
  segments: {
    items: [],
    isFetching: false,
    isError: false,
    messageError: null
  },
  subjects: {
    items: [],
    isFetching: false,
    isError: false,
    messageError: null
  },
  authors: {
    items: [],
    isFetching: false,
    isError: false,
    messageError: null
  },
  publishers: {
    items: [],
    isFetching: false,
    isError: false,
    messageError: null
  },
  grades: {
    items: [],
    isFetching: false,
    isError: false,
    messageError: null
  },
  twentyfirstCompetences: {
    items: [],
    isFetching: false,
    isError: false,
    messageError: null
  },
  twentyfirstSkills: {
    items: [],
    isFetching: false,
    isError: false,
    messageError: null
  },
  intelligenceScope: {
    items: [],
    isFetching: false,
    isError: false,
    messageError: null
  },
  onuGroups: {
    items: [],
    isFetching: false,
    isError: false,
    messageError: null
  },
  onuGoals: {
    items: [],
    isFetching: false,
    isError: false,
    messageError: null
  },
  oostSubjects: {
    items: [],
    isFetching: false,
    isError: false,
    messageError: null
  },
  sels: {
    items: [],
    isFetching: false,
    isError: false,
    messageError: null
  }
}
function EducationReducer (state = initialState, action) {
  switch (action.type) {
    case EducationActions.EDUCATION_SEGMENTS_FETCH_REQUEST:
      return {
        ...state,
        segments: {
          ...state.segments,
          isFetching: true,
          isError: false,
          messageError: null
        }
      }
    case EducationActions.EDUCATION_SEGMENTS_FETCH_SUCCESS:
      return {
        ...state,
        segments: {
          ...state.segments,
          items: action.payload,
          isFetching: false
        }
      }
    case EducationActions.EDUCATION_SEGMENTS_FETCH_ERROR:
      return {
        ...state,
        segments: {
          ...state.segments,
          isFetching: false,
          isError: true,
          messageError: action.payload
        }
      }
    case EducationActions.EDUCATION_SUBJECTS_FETCH_REQUEST:
      return {
        ...state,
        subjects: {
          ...state.subjects,
          isFetching: true,
          isError: false,
          messageError: null
        }
      }
    case EducationActions.EDUCATION_SUBJECTS_FETCH_SUCCESS:
      return {
        ...state,
        subjects: {
          ...state.subjects,
          items: action.payload,
          isFetching: false
        }
      }
    case EducationActions.EDUCATION_SUBJECTS_FETCH_ERROR:
      return {
        ...state,
        subjects: {
          ...state.subjects,
          isFetching: false,
          isError: true,
          messageError: action.payload
        }
      }
    case EducationActions.EDUCATION_AUTHORS_FETCH_REQUEST:
      return {
        ...state,
        authors: {
          ...state.authors,
          isFetching: true,
          isError: false,
          messageError: null
        }
      }
    case EducationActions.EDUCATION_AUTHORS_FETCH_SUCCESS:
      return {
        ...state,
        authors: {
          ...state.authors,
          items: action.payload,
          isFetching: false
        }
      }
    case EducationActions.EDUCATION_AUTHORS_FETCH_ERROR:
      return {
        ...state,
        authors: {
          ...state.authors,
          isFetching: false,
          isError: true,
          messageError: action.payload
        }
      }
    case EducationActions.EDUCATION_PUBLISHERS_FETCH_REQUEST:
      return {
        ...state,
        publishers: {
          ...state.publishers,
          isFetching: true,
          isError: false,
          messageError: null
        }
      }
    case EducationActions.EDUCATION_PUBLISHERS_FETCH_SUCCESS:
      return {
        ...state,
        publishers: {
          ...state.publishers,
          items: action.payload,
          isFetching: false
        }
      }
    case EducationActions.EDUCATION_PUBLISHERS_FETCH_ERROR:
      return {
        ...state,
        publishers: {
          ...state.publishers,
          isFetching: false,
          isError: true,
          messageError: action.payload
        }
      }
    case EducationActions.GRADES_FETCH_REQUEST:
      return {
        ...state,
        grades: {
          ...state.grades,
          isFetching: true,
          isError: false,
          messageError: null
        }
      }
    case EducationActions.GRADES_FETCH_SUCCESS:
      return {
        ...state,
        grades: {
          ...state.grades,
          items: action.payload.data,
          isFetching: false
        }
      }
    case EducationActions.GRADES_FETCH_ERROR:
      return {
        ...state,
        grades: {
          ...state.grades,
          isFetching: false,
          isError: true,
          messageError: action.payload
        }
      }
    // todo new actions reducers
    case EducationActions.TWENTYFIRST_COMPETENCES_FETCH_REQUEST:
      return {
        ...state,
        twentyfirstCompetences: {
          ...state.twentyfirstCompetences,
          isFetching: true,
          isError: false,
          messageError: null
        }
      }
    case EducationActions.TWENTYFIRST_COMPETENCES_FETCH_SUCCESS:
      return {
        ...state,
        twentyfirstCompetences: {
          ...state.twentyfirstCompetences,
          items: action.payload.data,
          isFetching: false
        }
      }
    case EducationActions.TWENTYFIRST_COMPETENCES_FETCH_ERROR:
      return {
        ...state,
        twentyfirstCompetences: {
          ...state.twentyfirstCompetences,
          isFetching: false,
          isError: true,
          messageError: action.payload
        }
      }
    case EducationActions.TWENTYFIRST_SKILLS_FETCH_REQUEST:
      return {
        ...state,
        twentyfirstSkills: {
          ...state.twentyfirstSkills,
          isFetching: true,
          isError: false,
          messageError: null
        }
      }
    case EducationActions.TWENTYFIRST_SKILLS_FETCH_SUCCESS:
      return {
        ...state,
        twentyfirstSkills: {
          ...state.twentyfirstSkills,
          items: action.payload.data,
          isFetching: false
        }
      }
    case EducationActions.TWENTYFIRST_SKILLS_FETCH_ERROR:
      return {
        ...state,
        twentyfirstSkills: {
          ...state.twentyfirstSkills,
          isFetching: false,
          isError: true,
          messageError: action.payload
        }
      }

    case EducationActions.INTELLIGENCE_SCOPE_FETCH_REQUEST:
      return {
        ...state,
        intelligenceScope: {
          ...state.intelligenceScope,
          isFetching: true,
          isError: false,
          messageError: null
        }
      }
    case EducationActions.INTELLIGENCE_SCOPE_FETCH_SUCCESS:
      return {
        ...state,
        intelligenceScope: {
          ...state.intelligenceScope,
          items: action.payload.data,
          isFetching: false
        }
      }
    case EducationActions.INTELLIGENCE_SCOPE_FETCH_ERROR:
      return {
        ...state,
        intelligenceScope: {
          ...state.intelligenceScope,
          isFetching: false,
          isError: true,
          messageError: action.payload
        }
      }
    case EducationActions.ONU_GROUPS_FETCH_REQUEST:
      return {
        ...state,
        onuGroups: {
          ...state.onuGroups,
          isFetching: true,
          isError: false,
          messageError: null
        }
      }
    case EducationActions.ONU_GROUPS_FETCH_SUCCESS:
      return {
        ...state,
        onuGroups: {
          ...state.onuGroups,
          items: action.payload.data,
          isFetching: false
        }
      }
    case EducationActions.ONU_GROUPS_FETCH_ERROR:
      return {
        ...state,
        onuGroups: {
          ...state.onuGroups,
          isFetching: false,
          isError: true,
          messageError: action.payload
        }
      }
    case EducationActions.ONU_GOALS_FETCH_REQUEST:
      return {
        ...state,
        onuGoals: {
          ...state.onuGoals,
          isFetching: true,
          isError: false,
          messageError: null
        }
      }
    case EducationActions.ONU_GOALS_FETCH_SUCCESS:
      return {
        ...state,
        onuGoals: {
          ...state.onuGoals,
          items: action.payload.data,
          isFetching: false
        }
      }
    case EducationActions.ONU_GOALS_FETCH_ERROR:
      return {
        ...state,
        onuGoals: {
          ...state.onuGoals,
          isFetching: false,
          isError: true,
          messageError: action.payload
        }
      }
    case EducationActions.OOST_SUBJECTS_FETCH_REQUEST:
      return {
        ...state,
        oostSubjects: {
          ...state.oostSubjects,
          isFetching: true,
          isError: false,
          messageError: null
        }
      }
    case EducationActions.OOST_SUBJECTS_FETCH_SUCCESS:
      return {
        ...state,
        oostSubjects: {
          ...state.oostSubjects,
          items: action.payload.data,
          isFetching: false
        }
      }
    case EducationActions.OOST_SUBJECTS_FETCH_ERROR:
      return {
        ...state,
        oostSubjects: {
          ...state.oostSubjects,
          isFetching: false,
          isError: true,
          messageError: action.payload
        }
      }

    case EducationActions.SELS_FETCH_REQUEST:
      return {
        ...state,
        sels: {
          ...state.sels,
          isFetching: true,
          isError: false,
          messageError: null
        }
      }
    case EducationActions.SELS_FETCH_SUCCESS:
      return {
        ...state,
        sels: {
          ...state.sels,
          items: action.payload.data,
          isFetching: false
        }
      }
    case EducationActions.SELS_FETCH_ERROR:
      return {
        ...state,
        sels: {
          ...state.sels,
          isFetching: false,
          isError: true,
          messageError: action.payload
        }
      }
    default:
      return state
  }
}

export default EducationReducer



// WEBPACK FOOTER //
// ./src/modules/education/reducers.js